import { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Icon,
} from "@mui/material";
import MDButton from "theme/components/MDButton";
import MDTypography from "theme/components/MDTypography";

const DialogContext = createContext();

export function AwaitDialogProvider({ children }) {
  const [dialogState, setDialogState] = useState({
    open: false,
    message: "",
    variant: "",
    resolver: null,
  });

  const show = (message, variant = "", title = null) =>
    new Promise((resolve) => {
      setDialogState({
        open: true,
        message,
        variant,
        title,
        resolver: resolve,
      });
    });

  const handleClose = () => {
    dialogState.resolver?.();
    setDialogState({
      open: false,
      title: dialogState.title,
      message: dialogState.message,
      variant: dialogState.variant,
      resolver: null,
    });
  };

  const iconMap = {
    success: "check_circle",
    error: "error",
    warning: "warning",
    info: "info",
  };

  const colorMap = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
  };

  return (
    <DialogContext.Provider value={{ show }}>
      {children}

      <Dialog open={dialogState.open} maxWidth="xs" fullWidth>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            py={2}
          >
            <MDTypography fontSize={64}>
              <Icon
                color={colorMap[dialogState.variant]}
              >
                {iconMap[dialogState.variant]}
              </Icon>
            </MDTypography>
            <MDTypography>
              {dialogState.title || dialogState.variant.toUpperCase()}
            </MDTypography>

            <MDTypography variant="subtitle2">
              {dialogState.message}
            </MDTypography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <MDButton
            variant="gradient"
            color={colorMap[dialogState.variant]}
            onClick={handleClose}
            fullWidth
          >
            OK
          </MDButton>
        </DialogActions>
      </Dialog>
    </DialogContext.Provider>
  );
}

export function useAwaitDialog() {
  return useContext(DialogContext);
}
